import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const names = ['María', 'Valentina', 'Martín', 'Camila', 'Nicolás', 'Luciana', 'Sofía', 'Juan', 'Agustina', 'Facundo'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Neuquén', 'Santa Fe'];
export const SocialProofPopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Hide after 4 seconds
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 5000);
    // Recurring timer
    const intervalTimer = setInterval(() => {
      showPopup();
    }, Math.floor(Math.random() * (12000 - 8000 + 1) + 8000)); // Every 8-12 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-129">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 bg-navy-800 border border-gold-500/30 rounded-lg p-4 shadow-2xl max-w-sm flex items-start gap-3" data-id="element-130">
          <div className="bg-gold-500/20 p-2 rounded-full mt-1" data-id="element-131">
            <CheckCircle className="w-5 h-5 text-gold-500" data-id="element-132" />
          </div>
          <div data-id="element-133">
            <p className="text-sm text-gray-300" data-id="element-134">
              <span className="font-bold text-white" data-id="element-135">{currentBuyer.name}</span>{' '}
              de {currentBuyer.city} acaba de comprar el KIT
            </p>
            <p className="text-xs text-gold-500 mt-1 font-medium" data-id="element-136">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};